import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEasInfoApi } from './types';

export const easInfo: TEasInfoApi = {
	getEasInfoList: (payload) =>
		http
			.get(endpoint.easInfo.LIST, {
				params: {
					GroupTitle: payload?.groupTitle || undefined,
					SearchString: payload?.searchString || undefined,
					PageSize: payload?.pageSize,
					PageNumber: payload?.pageNumber,
				},
			})
			.then((response) => response.data),
	getEasInfoGroups: () =>
		http.get(endpoint.easInfo.GROUPS).then((response) => response.data),
	patchEasInfo: (payload) =>
		http.patch(endpoint.easInfo.LIST, payload).then((response) => response.data),
	updateEasInfo: (payload) =>
		http.post(endpoint.easInfo.LIST, payload).then((response) => response.data),
};
